


























import { Component, Inject, Mixins, Prop } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";
import {
  ITemplateProvider,
  ITemplateProviderMethods
} from "@/models/providers/templates";
import i18n from "@/i18n";

@Component({
  components: {
    "template-content": () =>
      import("@/components/app/global/templates/contentForm.vue")
  }
})
export default class TemplateContentViewModal extends Mixins(HasValidation) {
  // Inject

  @Inject({ from: "templateProvider" })
  public templateProvider!: () => ITemplateProvider;

  @Inject({ from: "templateProviderMethods" })
  public $templateMethods!: ITemplateProviderMethods;

  // Props

  @Prop({ default: i18n.t("_action.preview_template") })
  public readonly title!: string;

  // Computed

  public get $templateData() {
    return this.templateProvider();
  }
}
